// extracted by mini-css-extract-plugin
var _1 = "MessageBubble__canvas--mdfgj";
var _2 = "MessageBubble__charClose--hTT0S MessageBubble__close--Yigew";
var _3 = "MessageBubble__close--Yigew";
var _4 = "MessageBubble__grok--ABdNr";
var _5 = "MessageBubble__instructions--LIAif";
var _6 = "MessageBubble__instructionsClose--kBCcQ MessageBubble__close--Yigew";
var _7 = "MessageBubble__kraken--ybzTo";
var _8 = "MessageBubble__slider--KfbOq";
var _9 = "MessageBubble__testoverview--RpI0R";
var _a = "MessageBubble__tutorial--m4Xhj";
export { _1 as "canvas", _2 as "charClose", _3 as "close", _4 as "grok", _5 as "instructions", _6 as "instructionsClose", _7 as "kraken", _8 as "slider", _9 as "testoverview", _a as "tutorial" }
